type VolumeBucket = [string | undefined, string];

export function compactVolumeDisplay(summary: string | undefined) {
  if (!summary) return summary;

  const buckets = summary
    .split("·")
    .map((part) => part.trim().match(/^(.+?)\s+([a-z]+)$/i))
    .filter((match): match is RegExpMatchArray => Boolean(match))
    .map((match) => [match[1], match[2]] as VolumeBucket);

  if (buckets.length <= 1) return summary;
  return compactVolumeBuckets(buckets);
}

export function compactVolumeBuckets(buckets: VolumeBucket[]) {
  const nonZero = buckets
    .map(([value, unit]) => [parseQuantity(value), unit] as const)
    .filter(([value]) => value !== 0);

  if (nonZero.length === 0) return "0 cx";
  if (nonZero.length === 1) {
    const [value, unit] = nonZero[0];
    return `${formatQuantity(value)} ${unit}`;
  }

  const total = nonZero.reduce((sum, [value]) => sum + value, 0);
  return `${formatQuantity(total)} vol`;
}

function parseQuantity(value: string | undefined) {
  if (!value) return 0;

  const normalized = value.trim();
  if (normalized.includes(",") && normalized.includes(".")) {
    return Number(normalized.replace(/\./g, "").replace(",", ".")) || 0;
  }
  if (/^\d{1,3}(?:\.\d{3})+$/.test(normalized)) {
    return Number(normalized.replace(/\./g, "")) || 0;
  }
  return Number(normalized.replace(",", ".")) || 0;
}

function formatQuantity(value: number) {
  return Number.isInteger(value) ? String(value) : String(value);
}
